import React, { Component, createRef } from "react";

class ProjectSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: props.value || "",
      filteredProjects: [],
      showDropdown: false,
      highlightedIndex: -1,
    };

    this.listRefs = [];
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ selectedOption: this.props.value });
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.keyDown, true);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyDown, true);
  }

  keyDown = (event) => {
    const { showDropdown, filteredProjects, highlightedIndex } = this.state;

    if (event.key === "Escape" && this.state.showDropdown) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({ showDropdown: false });
    }

    if (event.key === "ArrowDown") {
      event.preventDefault();
      if(!showDropdown){
        this.handleFocus()
      }

      this.setState(
        (prevState) => ({
          highlightedIndex: Math.min(prevState.highlightedIndex + 1, filteredProjects.length - 1),
        }),
        this.scrollToHighlightedItem
      );
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      this.setState(
        (prevState) => ({
          highlightedIndex: Math.max(prevState.highlightedIndex - 1, 0),
        }),
        this.scrollToHighlightedItem
      );
    }

    if (event.key === "Enter" && highlightedIndex >= 0) {
      event.preventDefault();
      this.handleSelect(filteredProjects[highlightedIndex]);
    }
  };

  scrollToHighlightedItem = () => {
    const { highlightedIndex } = this.state;
    if (this.listRefs[highlightedIndex]) {
      this.listRefs[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

  handleChange = (event) => {
    const value = event.target.value;
    const filteredProjects = this.getFilteredProjects(value);
    this.listRefs = new Array(filteredProjects.length).fill(null).map(() => createRef());
  
    this.setState({
      selectedOption: value,
      filteredProjects,
      showDropdown: filteredProjects.length > 0,
      highlightedIndex: -1,
    });
  
    this.props.onSelect(value);
  };

  handleSelect = (project) => {
    this.setState({
      selectedOption: project,
      filteredProjects: [],
      showDropdown: false,
      highlightedIndex: -1,
    });

    this.props.onSelect(project);
  };

  handleFocus = () => {
    const filteredProjects = this.getFilteredProjects("");
    this.listRefs = new Array(filteredProjects.length).fill(null).map(() => createRef());

    this.setState((prevState) => ({
      filteredProjects,
      showDropdown: !prevState.showDropdown, 
      highlightedIndex: -1,
    }));
  };

  getFilteredProjects = (query) => {
    return this.props.coachProjects
      .filter(
        (project) =>
          project.toLowerCase() !== "self-registered" &&
          project.toLowerCase().includes(query.toLowerCase())
      )
      .sort();
  };

  render() {
    return (
      <div className="styled-select input-wrapper-1" style={{ position: "relative", cursor:"pointer" }} onClick={this.handleFocus}>
        <input
          type="text"
          id="project-input"
          onChange={this.handleChange}
          value={this.state.selectedOption?.toLowerCase() === "self-registered" ? "" : this.state.selectedOption || ""}
          placeholder="Select or enter a project..."
          maxLength={45}
          required
        />

        {this.state.showDropdown && this.state.filteredProjects.length > 0 && (
          <ul className="dropdown-list">
            <div className="dropdown-scrollable">

            {this.state.filteredProjects.map((project, index) => (
              <li
                key={index}
                ref={(el) => (this.listRefs[index] = el)}
                onMouseDown={() => this.handleSelect(project)}
                className={this.state.highlightedIndex === index ? "highlighted" : ""}
              >
                {project}
              </li>
            ))}
            </div>

          </ul>
        )}

        <label>Project</label>
      </div>
    );
  }
}

export default ProjectSelect;
